/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';

/**
 * Renders the milestones data.
 *
 * @param {object} props - The props
 * @param {Array} props.milestones - The milestones data.
 * @param {boolean} props.isAFLW - Whether this is an AFLW match (determines URL format for external players)
 * @param {string} props.clubId - The player's club/team ID (used to determine if player is from different club)
 * @returns {React.JSX.Element}    - The formatted milestones component.
 */
export const TeamAnnouncementsMilestones = ({ milestones, isAFLW, clubId }) => {
    const teamLineupsContext = useContext(TeamLineupsContext);

    return (
        <p
            className={`team-announcements__milestones team-announcements__milestones`}
        >
            <span className="team-announcements__milestones-title team-announcements__list-title">
                {PULSE.I18N.lookup('label.teamannouncements.milestones')}
            </span>
            <span className="team-announcements__milestones-value team-announcements__list-values">
                {milestones.map((milestone, index) => (
                    <>
                        <PlayerProfileLink
                            key={milestone.playerId}
                            classes="team-announcements__link"
                            player={{
                                playerId: milestone?.player?.playerId,
                                firstName:
                                    milestone?.player?.playerName?.givenName,
                                surname: milestone?.player?.playerName?.surname
                            }}
                            trackingInfo={{
                                event: PULSE.app.common.CONSTANTS.TRACKING
                                    .EVENTS.SELECT.LINK,
                                component_name:
                                    PULSE.app.common.CONSTANTS.TRACKING.VALUES
                                        .TEAM_LINEUPS.VIEW.LIST,
                                component_content_type:
                                    teamLineupsContext === 'match-centre'
                                        ? PULSE.app.common.CONSTANTS.TRACKING
                                              .CONTENT_TYPES.MATCH_CENTRE
                                              .LINEUPS
                                        : PULSE.app.common.CONSTANTS.TRACKING
                                              .CONTENT_TYPES.LINEUPS
                            }}
                            isAFLW={isAFLW}
                            clubId={clubId}
                        >
                            {`${milestone?.player?.playerName?.givenName} ${milestone?.player?.playerName?.surname}`}
                        </PlayerProfileLink>
                        {` (${milestone?.milestoneEvent})${
                            index + 1 < milestones.length ? `, ` : ''
                        } `}
                    </>
                ))}
            </span>
        </p>
    );
};

TeamAnnouncementsMilestones.propTypes = {
    milestones: PropTypes.array,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.string
};
